import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import { Link } from 'react-router-dom';

function EvolutionPowerplayStrikeFun(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const brandName = 'Fun88'

    return (
        <>
            <InformationWrapper>
                <TitleConatiner>
                    <h2>enjoy premium live casino action on Crazy Time, Ice Fishing, <br />Lightning Roulette, and Super Andar Bahar</h2>
                    <p>Place qualifying bets and unlock <strong>winnings up to 10x your bet amount</strong></p>

                    <GameBlock>
                        <Link to="/live-casino/evolution/crazy-time">
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.evoPowerplayStrikeGame01}`}
                                alt="evolution-powerplay-strike"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </Link>
                        <Link to="/live-casino/evolution/ice-fishing">
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.evoPowerplayStrikeGame02}`}
                                alt="evolution-powerplay-strike"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </Link>
                        <Link to="/live-casino/evolution/lightning-roulette">
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.evoPowerplayStrikeGame03}`}
                                alt="evolution-powerplay-strike"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </Link>
                        <Link to="/live-casino/evolution/super-andar-bahar">
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.evoPowerplayStrikeGame04}`}
                                alt="evolution-powerplay-strike"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </Link>
                    </GameBlock>
                </TitleConatiner>
                <br />
                
                
             
                <HTPWrap>
                    <h2 className='text-lowercase'>How to Participate</h2>
                    <br />
                    <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.evoPowerplayStrikeSteps}`}
                            alt="evolution-powerplay-strike"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                    />
                </HTPWrap>

                <Container>
                    <h2 className='text-lowercase'>Terms & Conditions</h2>
                    <RightCradWrapper>
                        <RightCard><p>Valid from <strong>1 March to 31st May 2026</strong></p></RightCard>
                        <RightCard><p>Applicable only on<strong> Crazy Time, Ice Fishing, Lightning <br /> Roulette, and Super Andar Bahar</strong></p></RightCard>
                        <RightCard><p>Players must place a <strong>minimum of 10 bets</strong> to qualify</p></RightCard>
                        <RightCard><p>Minimum bet amount <strong>₹1,000 per bet</strong></p></RightCard>
                        <RightCard><p>Maximum bonus/winnings per user per week <strong>₹10,000</strong></p></RightCard>
                        <RightCard><p>Promotion is <strong>valid once per user per week</strong></p></RightCard>
                        <RightCard><p>Promotion is available to the <strong>first 1,000 eligible players each week</strong> on a first-come, first-served basis</p></RightCard>
                        <RightCard><p>Bonus/winnings are credited after completion of all qualifying bets</p></RightCard>
                        <RightCard><p>Promotion benefits are applicable only on<strong> Evolution live casino games</strong></p></RightCard>
                        <RightCard><p>Bonus wagering requirements apply, if applicable</p></RightCard>
                      <RightCard><p>Eligible games or tables may change without prior 
    notice.</p></RightCard>
                        <RightCard><p><strong>{brandName}</strong> reserves the right to modify, suspend, or cancel the promotion without prior notice</p></RightCard>
                        <RightCard><p>General<strong> Live Casino Terms & Conditions </strong>apply</p></RightCard>
                    </RightCradWrapper>
                </Container>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(EvolutionPowerplayStrikeFun));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1rem 0 2rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #EBEBEB;
    overflow: hidden;
    color: #fff;
    text-transform: capitalize;

    h2 {
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-family: 'Inter-Bold';
        line-height: normal;
        text-transform: uppercase;
        margin: 0;
        color: #06A6FF;
    }

    .text-lowercase {
        text-transform: capitalize;
    }
`;

const TitleConatiner = styled.div`
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1.2rem;
    padding: 1rem 0;
    background: #fff;
    border-radius: 7px;
    padding: 20px 10px;
    margin: auto;

    p {
        color: #444;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        text-transform: capitalize;
        margin: 0;
    }
`;

const GameBlock = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    a {
        cursor: pointer;
        width: 178px;
         img {
            max-width: 100%;
         }
    }
`;

const Container = styled.div`
    width: 80%;
    background: #fff;
    border-radius: 7px;
    padding: 20px 10px;
    margin: 2em auto 0 auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    padding: 2rem 1rem 2rem 1rem;
    
`;

const RightCradWrapper = styled.ul`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex: 1;
    gap: 10px;
    margin: 0;
    padding: 0;
    
`;

const RightCard = styled.li`
    width: 60%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    background: #EBEBEB;
    padding: 5px 25px 5px 65px;
    position: relative;

    p {
        color: #444;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
        text-transform: capitalize;
        margin: 0;
        padding-left: 5px;

        ::before {
            content: '✦';
            position: absolute;
            left: 50px;
            top: 5px;
        }
    }
`;


const HTPWrap = styled.div`
    width: 80%;
    height: auto;
    margin-bottom: 3em;
    background: #fff;
    border-radius: 7px;
    padding: 20px 10px;
    margin: auto;

    & span {
        display: flex !important;
        justify-content: center !important;
        & img {
            width: 80%;
            height: auto;
        }
    }
`